import React from "react";
import CryptoAccount from "./CryptoAccount";

const CryptoIndex = ({ section, setSection, exitModal }) => {
  let CurrentPage;
  switch (section) {
    case 0:
      CurrentPage = (
        <CryptoAccount exitModal={exitModal} setSection={setSection} />
      );
      break;
    default:
  }
  return <div className="current-page">{CurrentPage}</div>;
};
export default CryptoIndex;
